import { ViewMoreButton, UpArrow, DownArrow } from './InternalLinkMod.styles';

type OwnProps = {
  isExpanded: boolean;
  toggleExpand: () => void;
};

export default function ExpandButton({ isExpanded, toggleExpand }: OwnProps) {
  const content = isExpanded
    ? {
        title: 'VIEW LESS',
        Icon: () => <UpArrow />
      }
    : {
        title: 'VIEW MORE',
        Icon: () => <DownArrow />
      };

  return (
    <ViewMoreButton
      data-analytics-id={content.title}
      data-testid="view-more-or-less"
      onClick={toggleExpand}
    >
      {content.title}
      <content.Icon />
    </ViewMoreButton>
  );
}
